module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/ext-layout/ext-layout.component.scss
// module id = ./src/app/layouts/ext-layout/ext-layout.component.scss
// module chunks = main